import useMediaQuery from "./useMediaQuery";

const MOBILE_BREAKPOINT = 768;

export default function useMobile() {
	const isMobile = useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
	return isMobile;
}
